export default "__VITE_ASSET__6n5ON94Z__"